import React from 'react';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusesSection } from './components/BonusesSection';
import { Footer } from './components/Footer';
import { GuaranteeFaq } from './components/GuaranteeFaq';
import { Hero } from './components/Hero';
import { OfferSection } from './components/OfferSection';
import { PainPoints } from './components/PainPoints';
import { RecipeCategories } from './components/RecipeCategories';
import { ScienceSection } from './components/ScienceSection';
import { Testimonials } from './components/Testimonials';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream text-forest" data-id="element-0" data-mp="31b8ko1mmwhas">
      <Hero data-id="element-1" data-mp="2wk06ksad07ra" />
      <ScienceSection data-id="element-2" data-mp="2wjgrrkg09zhh" />
      <PainPoints data-id="element-3" data-mp="2wiyuqllirh8i" />
      <BenefitsSection data-id="element-4" data-mp="2wifc12o1ootf" />
      <RecipeCategories data-id="element-5" data-mp="2wi5l9cv6edmo" />
      <BonusesSection data-id="element-6" data-mp="28tw5osok2m3z" />
      <Testimonials data-id="element-7" data-mp="28te37ebavbnm" />
      <OfferSection data-id="element-8" data-mp="28sl32w6ujkeg" />
      <GuaranteeFaq data-id="element-9" data-mp="28s2xh8yanttv" />
      <Footer data-id="element-10" data-mp="23vkuadim43jn" />
    </div>;
}